module.exports = {"530304001":"通泉街道","530304002":"鸡头村街道","530304003":"王家庄街道","530304004":"张安屯街道","530304005":"旧县街道","530304100":"马过河镇","530304101":"纳章镇","530304200":"马鸣乡","530304201":"大庄乡","530304202":"月望乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530304.json
// module id = 2689
// module chunks = 0